import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { captureAttribution } from './utils/attribution';

// Before React renders a frame: the Google SSO redirect and handleGoHome's
// pushState both strip the query string later in the session.
captureAttribution();

// Finish an interrupted /join/ trip. Google SSO from a join link stashes the
// path before redirecting; if Supabase's allow-list bounced the deep redirect
// and dropped us on the bare origin, hop back to the game. One-shot (consumed
// immediately) and stale after 10 minutes, so it can never hijack a later
// visit. Runs pre-mount so the app never double-boots.
try {
  const raw = sessionStorage.getItem('kyg_pending_join');
  if (raw) {
    sessionStorage.removeItem('kyg_pending_join');
    const { path, ts } = JSON.parse(raw);
    const fresh = typeof ts === 'number' && Date.now() - ts < 10 * 60 * 1000;
    if (fresh && typeof path === 'string' && path.startsWith('/join/') &&
        window.location.pathname !== path) {
      window.location.replace(path);
    }
  }
} catch (e) { /* attribution rule applies here too: never block boot */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
